import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import PaginationURL from "util/PaginationURL";
import deserializeLookupTables from "components/lookup-tables/lookup-table-list/utils";
import deserializeCaches from "components/lookup-tables/cache-list/utils";
import deserializeDataAdapters from "components/lookup-tables/adapter-list/utils";
const _url = (path) => qualifyUrl(`/system/lookup/${path}`);
const _urlClusterWise = (path) => qualifyUrl(`/cluster/system/lookup/${path}`);
export const fetchAllLookupTables = async (resolve = false) => {
  const url = _url(PaginationURL("tables", 1, 0, void 0, { resolve }));
  return fetch("GET", url).then((response) => response.lookup_tables);
};
export const deleteLookupTable = async (tableId) => fetch("DELETE", _url(`tables/${tableId}`));
export const fetchErrors = async ({
  lutNames = void 0,
  cacheNames = void 0,
  adapterNames = void 0
}) => {
  const request = {};
  if (lutNames) request.tables = lutNames;
  if (cacheNames) request.caches = cacheNames;
  if (adapterNames) request.data_adapters = adapterNames;
  return fetch("POST", _url("errorstates"), request);
};
export const fetchPaginatedLookupTables = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const url = _url(
    PaginationURL("tables", page, pageSize, query, { resolve: true, sort: sortField, order: sortOrder })
  );
  return fetch("GET", url).then(deserializeLookupTables);
};
export const fetchLookupTable = async (idOrName) => fetch("GET", _url(`tables/${idOrName}?resolve=true`));
export const createLookupTable = async (payload) => fetch("POST", _url("tables"), payload);
export const updateLookupTable = async (payload) => fetch("PUT", _url(`tables/${payload.id}`), payload);
export const purgeLookupTableKey = async ({ table, key }) => fetch("POST", _urlClusterWise(`tables/${table.id}/purge?key=${encodeURIComponent(key)}`));
export const purgeAllLookupTableKey = async (table) => fetch("POST", _urlClusterWise(`tables/${table.id}/purge`));
export const testLookupTableKey = async ({ tableName, key }) => fetch("GET", _url(`tables/${tableName}/query?key=${encodeURIComponent(key)}`));
export const fetchLookupPreview = async (idOrName, size) => fetch("GET", qualifyUrl(`/system/lookup/tables/preview/${idOrName}?size=${size}`));
export const fetchPaginatedCaches = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const url = _url(PaginationURL("caches", page, pageSize, query, { sort: sortField, order: sortOrder }));
  return fetch("GET", url).then(deserializeCaches);
};
export const fetchCache = async (idOrName) => fetch("GET", _url(`caches/${idOrName}`));
export const fetchCacheTypes = async () => fetch("GET", _url("types/caches"));
export const validateCache = async (cache) => fetch("POST", _url("caches/validate"), cache);
export const createCache = async (payload) => fetch("POST", _url("caches"), payload);
export const updateCache = async (payload) => fetch("PUT", _url(`caches/${payload.id}`), payload);
export const deleteCache = async (cacheId) => fetch("DELETE", _url(`caches/${cacheId}`));
export const fetchPaginatedDataAdapters = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const url = _url(PaginationURL("adapters", page, pageSize, query, { sort: sortField, order: sortOrder }));
  return fetch("GET", url).then(deserializeDataAdapters);
};
export const fetchDataAdapter = async (idOrName) => fetch("GET", _url(`adapters/${idOrName}`));
export const fetchDataAdapterTypes = async () => fetch("GET", _url("types/adapters"));
export const createDataAdapter = async (payload) => fetch("POST", _url("adapters"), payload);
export const updateDataAdapter = async (payload) => fetch("PUT", _url(`adapters/${payload.id}`), payload);
export const validateDataAdapter = async (adapter) => fetch("POST", _url("adapters/validate"), adapter);
export const deleteDataAdapter = async (adapterId) => fetch("DELETE", _url(`adapters/${adapterId}`));
export const lookupDataAdapter = async (adapterName, key) => fetch("GET", _url(`adapters/${adapterName}/query?key=${encodeURIComponent(key)}`));
